import $ from 'jquery';
import { decode as rawBase64Decode, encode as base64_encode } from 'base-64';
import { CONFIG, ENDERECO_API } from '../../config/constant';
import { showDuplicateLoginAlert } from '../../components/Auth/DuplicateLoginAlert';

const normalizeUsersResponse = (value) => {
  if (typeof value !== 'string') {
    return value;
  }

  let normalizedValue = value.trim();

  if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
    normalizedValue = JSON.parse(normalizedValue);
  }

  return normalizedValue;
};

const base64_decode = (value) => rawBase64Decode(normalizeUsersResponse(value));

const isUsersAuthError = (xhr) => {
  const candidates = [xhr?.message, xhr?.responseText, xhr?.responseJSON];

  return candidates.some((value) => {
    if (value === 'erro_auth') {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    let normalizedValue = value.trim();

    if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
      normalizedValue = JSON.parse(normalizedValue);
    }

    try {
      normalizedValue = base64_decode(normalizedValue);
    } catch (err) {
      return normalizedValue === 'erro_auth';
    }

    return normalizedValue === 'erro_auth';
  });
};

const handleUsersError = (xhr, reject, rejectMessage) => {
  if (isUsersAuthError(xhr)) {
    showDuplicateLoginAlert();
  }

  reject([400, { message: rejectMessage }]);
};

const JWT_SECRET = CONFIG.jwt.secret;
const jose = require('jose');

const getSessionUsers = () => {
  if (sessionStorage.getItem('ddesp') === null) {
    return [];
  }

  return JSON.parse(base64_decode(sessionStorage.getItem('ddesp')));
};

const getUsersContext = () => {
  const users = getSessionUsers();

  return {
    users,
    emp: users[0] || 0,
    uid: users[3] || 0,
    token: users[14] || '',
  };
};

const getUsersHeaders = ({ token = '', includeContentType = false, includeAuthorization = true } = {}) => {
  const headers = {};

  if (includeContentType) {
    headers['Content-Type'] = 'application/json';
  }

  if (includeAuthorization && token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

const encodeUsersPayload = (emp, uid, dataPost) => [
  base64_encode(emp),
  base64_encode(uid),
  base64_encode(JSON.stringify(dataPost)),
];

const ajaxUsersEvent = ({
  type,
  ll,
  dd,
  headers = {},
  parseType = 'base64',
  rejectMessage = 'Dados não localizados',
  extraData = {},
  encodeDd = true,
}) => new Promise(function (resolve, reject) {
  try {
    $.ajax({
      url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
      type,
      dataType: 'text',
      headers,
      data: {
        pp: base64_encode('user'),
        ll: base64_encode(ll),
        dd: encodeDd ? base64_encode(JSON.stringify(dd)) : dd,
        ...extraData,
      },
      success: function (data) {
        if (parseType === 'jsonBase64') {
          resolve([200, JSON.parse(base64_decode(data))]);
          return;
        }

        if (parseType === 'base64') {
          resolve([200, base64_decode(data)]);
          return;
        }

        resolve([200, data]);
      },
      error: function (xhr) {
        handleUsersError(xhr, reject, rejectMessage);
      },
    });
  } catch (err) {
    reject([500, { message: 'Server Error' }]);
  }
});

const verifyToken = async (uid, empid) => {
  // const serviceToken = users[14];
  // const Issuer = 'urn:emid:' + base64_encode(empid);
  // const Audience = 'urn:uuid:' + base64_encode(uid);

  // const secret = new TextEncoder().encode(JWT_SECRET);
  // const {payload} = await jose.jwtVerify(serviceToken, secret, {
  //   issuer: Issuer,
  //   audience: Audience,
  // });

  // return payload.userId;
};

const RestUsersPost = async (config) => {
  const Arr_ = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();
  const { users, emp, uid, token } = getUsersContext();
  const authHeaders = getUsersHeaders({ token });
  const authGetHeaders = getUsersHeaders({ token, includeContentType: true });

  //const verify_ = await verifyToken(uid, emp);
  // verifyToken(uid, emp).then((userId) => {
  const encodedString = emp + '|' + uid;
  //if (verify_ === encodedString) {
  switch (caminho) {
    case 'alteraStatusUsuario':
      return ajaxUsersEvent({ type: 'POST', ll: 'alteraStatusUsuario', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authHeaders });
    case 'alterarNome':
      return ajaxUsersEvent({ type: 'POST', ll: 'alterarNome', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authHeaders });
    case 'alterarSenhaUser':
      return ajaxUsersEvent({
        type: 'POST',
        ll: 'alterarSenhaUser',
        dd: encodeUsersPayload(emp, uid, Arr_.dataPost),
        headers: authHeaders,
        extraData: { stepUpToken: Arr_.stepUpToken ?? '' },
      });
    case 'convite':
      return ajaxUsersEvent({
        type: 'GET',
        ll: 'conviteUser',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost)), base64_encode(users[1])],
        headers: authGetHeaders,
      });
    case 'deletarGrupo':
      return ajaxUsersEvent({ type: 'GET', ll: 'deletarGrupo', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authGetHeaders });
    case 'deletarUsuario':
      return ajaxUsersEvent({ type: 'GET', ll: 'deletarUsuario', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authGetHeaders });
    case 'getEmpresasByGrupo':
      return ajaxUsersEvent({ type: 'GET', ll: 'empresasPorGrupo', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authGetHeaders, parseType: 'jsonBase64' });
    case 'getEmpresasByUser':
      return ajaxUsersEvent({ type: 'GET', ll: 'empresasPorUsuario', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authGetHeaders, parseType: 'jsonBase64' });
    case 'getGrupoPermissions':
      return ajaxUsersEvent({ type: 'GET', ll: 'permissoesPorGrupo', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authGetHeaders, parseType: 'jsonBase64' });
    case 'getUserPermissions':
      return ajaxUsersEvent({ type: 'GET', ll: 'permissoesPorUsuario', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authGetHeaders, parseType: 'jsonBase64' });
    case 'img_perfil':
      return ajaxUsersEvent({ type: 'POST', ll: 'changeImgPerfil', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authHeaders });
    case 'novoGrupo':
      return ajaxUsersEvent({ type: 'GET', ll: 'novoGrupo', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authGetHeaders });
    case 'changeUserGroup':
      return ajaxUsersEvent({ type: 'GET', ll: 'changeUserGroup', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authGetHeaders });
    case 'reenviarConvite':
      return ajaxUsersEvent({
        type: 'GET',
        ll: 'reenviarConvite',
        dd: encodeUsersPayload(emp, uid, Arr_.dataPost),
        headers: authGetHeaders,
      });
    case 'savePermissionsByGroup':
      return ajaxUsersEvent({ type: 'GET', ll: 'savePermissionsByGroup', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authGetHeaders });
    case 'savePermissionsByUser':
      return ajaxUsersEvent({ type: 'GET', ll: 'savePermissionsByUser', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authGetHeaders });
    case 'getIaLimitePermissoes':
      return ajaxUsersEvent({ type: 'GET', ll: 'getIaLimitePermissoes', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authGetHeaders, parseType: 'jsonBase64' });
    case 'saveUserGrupo':
      return ajaxUsersEvent({ type: 'GET', ll: 'saveUserGrupo', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authGetHeaders });
    case 'updateGrupoSobre':
      return ajaxUsersEvent({ type: 'GET', ll: 'updateGrupoSobre', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authGetHeaders });
    case 'updateGrupoNome':
      return ajaxUsersEvent({ type: 'GET', ll: 'updateGrupoNome', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authGetHeaders });
    case 'desvincularConta':
      return ajaxUsersEvent({ type: 'GET', ll: 'desvincularConta', dd: encodeUsersPayload(emp, uid, ['']), headers: authGetHeaders });
    case 'saveHorariosAcesso':
      return ajaxUsersEvent({ type: 'POST', ll: 'saveHorariosAcesso', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao salvar horários' });
    case 'saveHorariosAtivo':
    case 'getRelatoriosPermissoes':
      return ajaxUsersEvent({ type: 'GET', ll: 'getRelatoriosPermissoes', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authGetHeaders });
    case 'getMinhasPermissoesRelatorios':
      return ajaxUsersEvent({ type: 'GET', ll: 'getMinhasPermissoesRelatorios', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authGetHeaders });
    case 'saveRelatoriosPermissoes':
      return ajaxUsersEvent({ type: 'GET', ll: 'saveRelatoriosPermissoes', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authGetHeaders });
    case 'ajuda':
      return ajaxUsersEvent({ type: 'POST', ll: 'saveHorariosAtivo', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao atualizar ativação' });
    case 'deleteHorariosAcesso':
      return ajaxUsersEvent({ type: 'POST', ll: 'deleteHorariosAcesso', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao deletar horários' });
    case 'saveHorariosTemplate':
      return ajaxUsersEvent({ type: 'POST', ll: 'saveHorariosTemplate', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao salvar template' });
    case 'deleteHorariosTemplate':
      return ajaxUsersEvent({ type: 'POST', ll: 'deleteHorariosTemplate', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao deletar template' });
    case 'InsertIpGlobal':
      return ajaxUsersEvent({ type: 'POST', ll: 'InsertIpGlobal', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao salvar whitelist IP' });
    case 'InsertIPUser':
      return ajaxUsersEvent({ type: 'POST', ll: 'InsertIPUser', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao salvar whitelist IP' });
    case 'DeleteIPUser':
      return ajaxUsersEvent({ type: 'POST', ll: 'DeleteIPUser', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao salvar whitelist IP' });
    case 'UpdateIpAtivo':
      return ajaxUsersEvent({ type: 'POST', ll: 'UpdateIpAtivo', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao atualizar status do IP' });
    case 'whiteListSeguranca':
      return ajaxUsersEvent({ type: 'POST', ll: 'whiteListSeguranca', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao salvar whitelist IP' });
    case 'saveWhitelistIp':
      return ajaxUsersEvent({ type: 'POST', ll: 'saveWhitelistIp', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao salvar whitelist IP' });
    case 'saveParametroSessao':
      return ajaxUsersEvent({ type: 'POST', ll: 'saveParametroSessao', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao salvar tempo de sessao' });
    case 'saveToolbarConfig':
      return ajaxUsersEvent({ type: 'POST', ll: 'saveToolbarConfig', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao salvar configuração da toolbar' });
    case 'saveMenuInicialConfig':
      return ajaxUsersEvent({ type: 'POST', ll: 'saveMenuInicialConfig', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao salvar menu inicial' });
    case 'saveContaRecursosConfig':
      return ajaxUsersEvent({ type: 'POST', ll: 'saveContaRecursosConfig', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao salvar recursos da conta' });
    case 'renovarSessaoIdle':
      return new Promise(function (resolve) {
        try {
          ajaxUsersEvent({ type: 'POST', ll: 'renovarSessaoIdle', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authHeaders, parseType: 'raw' })
            .then(() => resolve([200, { ok: true }]))
            .catch(() => resolve([200, { ok: false }]));
        } catch (err) {
          resolve([200, { ok: false }]);
        }
      });
    case 'saveWhitelistAtivo':
      return ajaxUsersEvent({ type: 'POST', ll: 'saveWhitelistAtivo', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao atualizar ativação whitelist' });
    case 'saveWhitelistIpBatch':
      return ajaxUsersEvent({ type: 'POST', ll: 'saveWhitelistIpBatch', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao salvar whitelist em lote' });
    case 'saveZipConfig':
      return ajaxUsersEvent({ type: 'POST', ll: 'saveZipConfig', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao salvar configuração ZIP' });
    case 'forcarLogout':
      return ajaxUsersEvent({ type: 'POST', ll: 'forcarLogout', dd: encodeUsersPayload(emp, uid, Arr_.dataPost), headers: authHeaders, rejectMessage: 'Erro ao forçar logout' });
    case 'salvarApiPermissoes':
      return ajaxUsersEvent({
        type: 'POST',
        ll: 'salvarApiPermissoes',
        dd: encodeUsersPayload(emp, uid, Arr_.dataPost),
        headers: authHeaders,
        parseType: 'jsonBase64',
        rejectMessage: 'Erro ao salvar permissões',
      });

    default:
      return new Promise(function (resolve, reject) {
        reject([404, { message: 'Rota não encontrada' }]);
      });
  }
  // } else {
  //   window.location.href = '/auth/login';
  // }
  // });
};

const RestUsersGet = async (config) => {
  const caminho = config.dest.trim();
  const { users, emp, uid, token } = getUsersContext();
  const authHeaders = getUsersHeaders({ token });
  const authGetHeaders = getUsersHeaders({ token, includeContentType: true });

  // const verify_ = await verifyToken(uid, emp);
  // const encodedString = emp + '|' + uid;
  // if (verify_ === encodedString) {
  switch (caminho) {
    case 'ajuda':
      return ajaxUsersEvent({ type: 'GET', ll: 'ajuda', dd: encodeUsersPayload(emp, uid, config.dataPost), headers: authGetHeaders, parseType: 'jsonBase64' });
    case 'carregaMenu':
      return ajaxUsersEvent({ type: 'GET', ll: 'carregaMenu', dd: [base64_encode(emp), base64_encode(uid), base64_encode(users[7])], headers: authGetHeaders });
    case 'empresas':
      return ajaxUsersEvent({ type: 'GET', ll: 'tableempresas', dd: [base64_encode(emp), base64_encode(uid), base64_encode(users[7])], headers: authGetHeaders, parseType: 'jsonBase64' });
    case 'geratkApiUs':
      return ajaxUsersEvent({
        type: 'GET',
        ll: 'geratkApiUs',
        dd: encodeUsersPayload(emp, uid, [users[7]]),
        headers: authGetHeaders,
        extraData: { stepUpToken: config.stepUpToken ?? (config.data ? (JSON.parse(config.data).stepUpToken ?? '') : '') },
      });
    case 'getkApi':
      return ajaxUsersEvent({ type: 'GET', ll: 'getkApi', dd: encodeUsersPayload(emp, uid, config.dataPost), headers: authGetHeaders, parseType: 'jsonBase64' });
    case 'logs':
      return ajaxUsersEvent({ type: 'GET', ll: 'newGetLog', dd: encodeUsersPayload(emp, uid, config.dataPost), headers: authGetHeaders, parseType: 'jsonBase64' });
    case 'setores':
      return ajaxUsersEvent({ type: 'GET', ll: 'getSetores', dd: [base64_encode(emp), base64_encode(uid)], headers: authGetHeaders, parseType: 'jsonBase64' });
    case 'setoresEusuarios':
      return ajaxUsersEvent({ type: 'GET', ll: 'carregaSetoreseUsuarios', dd: [base64_encode(emp), base64_encode(uid)], headers: authGetHeaders, parseType: 'jsonBase64' });
    case 'userBysetor':
      return ajaxUsersEvent({ type: 'GET', ll: 'userBysetor', dd: encodeUsersPayload(emp, uid, config.setorId), headers: authGetHeaders, parseType: 'jsonBase64' });
    case 'userByTk':
      return ajaxUsersEvent({
        type: 'GET',
        ll: 'userByTk',
        dd: [base64_encode(emp), base64_encode(uid), config.dataPost],
        headers: getUsersHeaders({ includeContentType: true, includeAuthorization: false }),
        parseType: 'jsonBase64',
        encodeDd: false,
      });
    case 'getMenuTreeView':
      return ajaxUsersEvent({ type: 'GET', ll: 'getMenuTreeView', dd: [base64_encode(emp), base64_encode(uid)], headers: authGetHeaders, parseType: 'jsonBase64' });
    case 'users':
      return ajaxUsersEvent({ type: 'GET', ll: 'tabelausuarios', dd: [base64_encode(emp), base64_encode(uid), base64_encode(users[7])], headers: authGetHeaders, parseType: 'jsonBase64' });
    case 'notificacoes':
      return new Promise(function (resolve) {
        resolve([200, []]);
      });
    case 'notificacoesLidas':
      return new Promise(function (resolve) {
        resolve([200, []]);
      });
    case 'getIngestEmail':
      return ajaxUsersEvent({ type: 'GET', ll: 'getIngestEmail', dd: [base64_encode(emp), base64_encode(uid)], headers: authGetHeaders, parseType: 'jsonBase64' });
    case 'getHorariosAcesso':
      return ajaxUsersEvent({ type: 'GET', ll: 'getHorariosAcesso', dd: encodeUsersPayload(emp, uid, config.dataPost), headers: authGetHeaders, parseType: 'jsonBase64' });
    case 'getHorariosTemplates':
      return ajaxUsersEvent({ type: 'GET', ll: 'getHorariosTemplates', dd: [base64_encode(emp), base64_encode(uid)], headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao carregar templates' });
    case 'getResumoHorariosAcesso':
      return ajaxUsersEvent({ type: 'GET', ll: 'getResumoHorariosAcesso', dd: encodeUsersPayload(emp, uid, config.dataPost), headers: authGetHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao carregar resumo de horários' });
    case 'getHorariosTemplate':
      return ajaxUsersEvent({ type: 'GET', ll: 'getHorariosTemplate', dd: encodeUsersPayload(emp, uid, config.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao carregar template' });
    case 'WhiteListBegin':
      return ajaxUsersEvent({ type: 'GET', ll: 'WhiteListBegin', dd: encodeUsersPayload(emp, uid, config.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao carregar whitelist' });
    case 'getUserWlist':
      return ajaxUsersEvent({ type: 'GET', ll: 'getUserWlist', dd: encodeUsersPayload(emp, uid, config.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao carregar whitelist' });
    case 'getUsersWithIp':
      return ajaxUsersEvent({ type: 'GET', ll: 'getUsersWithIp', dd: encodeUsersPayload(emp, uid, config.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao carregar whitelist' });
    case 'getLogsAcesso':
      return ajaxUsersEvent({ type: 'GET', ll: 'getLogsAcesso', dd: encodeUsersPayload(emp, uid, config.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao carregar logs de acesso' });
    case 'getWhitelistIp':
      return ajaxUsersEvent({ type: 'GET', ll: 'getWhitelistIp', dd: encodeUsersPayload(emp, uid, config.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao carregar whitelist' });
    case 'getResumoWhitelistIp':
      return ajaxUsersEvent({ type: 'GET', ll: 'getResumoWhitelistIp', dd: [base64_encode(emp), base64_encode(uid)], headers: authGetHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao carregar resumo whitelist' });
    case 'getParametroSessao':
      return ajaxUsersEvent({ type: 'GET', ll: 'getParametroSessao', dd: [base64_encode(emp), base64_encode(uid)], headers: authGetHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao carregar parametro sessao' });
    case 'getToolbarConfig':
      return ajaxUsersEvent({ type: 'GET', ll: 'getToolbarConfig', dd: [base64_encode(emp), base64_encode(uid)], headers: authGetHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao carregar configuração da toolbar' });
    case 'getMenuInicialConfig':
      return ajaxUsersEvent({ type: 'GET', ll: 'getMenuInicialConfig', dd: [base64_encode(emp), base64_encode(uid)], headers: authGetHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao carregar menu inicial' });
    case 'getContaRecursosConfig':
      return ajaxUsersEvent({ type: 'GET', ll: 'getContaRecursosConfig', dd: [base64_encode(emp), base64_encode(uid)], headers: authGetHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao carregar recursos da conta' });
    case 'keepAlive':
      return new Promise(function (resolve) {
        try {
          ajaxUsersEvent({ type: 'GET', ll: 'keepAlive', dd: [base64_encode(emp), base64_encode(uid)], headers: authGetHeaders, parseType: 'raw' })
            .then(() => resolve([200, {}]))
            .catch(() => resolve([200, {}]));
        } catch (err) {
          resolve([200, {}]);
        }
      });
    case 'getIpBack':
      return ajaxUsersEvent({ type: 'GET', ll: 'getIpBack', dd: encodeUsersPayload(emp, uid, config.dataPost), headers: authHeaders, parseType: 'jsonBase64', rejectMessage: 'Erro ao carregar whitelist' });
    case 'apiEndpoints':
      return new Promise(function (resolve, reject) {
        try {
          const dataPost_ = [base64_encode(emp), base64_encode(uid)];
          const serviceToken = window.localStorage.getItem('serviceToken');
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'GET',
            dataType: 'json',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + serviceToken,
            },
            data: {
              pp: base64_encode('user'),
              ll: base64_encode('apiEndpoints'),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = JSON.parse(base64_decode(data));
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, { message: 'Dados não localizados' }]);
            },
          });
        } catch (err) {
          reject([500, { message: 'Server Error' }]);
        }
      });

    default:
      return new Promise(function (resolve, reject) {
        reject([404, { message: 'Rota não encontrada' }]);
      });
  }
  /*axiosN.post('http://
  }*/
  // } else {
  //   window.location.href = '/auth/login';
  // }
  // });
};

export { RestUsersPost, RestUsersGet };
